import { render, staticRenderFns } from "./TakeAwayMenuCategory.vue?vue&type=template&id=111a989d&"
import script from "./TakeAwayMenuCategory.vue?vue&type=script&lang=ts&"
export * from "./TakeAwayMenuCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports